import { Badge as UiBadge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

import { badgeVariants, type BadgeVariants } from '../../configs/badge.config'

import type { ComponentProps } from 'react'

export function Badge({ className, variant, size, ...props }: ComponentProps<typeof UiBadge> & BadgeVariants) {
  return <UiBadge className={cn(badgeVariants({ variant, size }), className)} {...props} />
}
